import type { SerializedTransferStage, TransferStatus } from '@platform/shared-types';

export const money = (cents: number) => `$${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const when = (ms?: number) => (ms ? new Date(ms).toLocaleString(undefined, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');
export const ago = (ms?: number) => {
  if (!ms) return '';
  const h = Math.floor((Date.now() - ms) / 3_600_000);
  return h < 1 ? 'just now' : h < 48 ? `${h}h` : `${Math.floor(h / 24)}d`;
};

export const OWNER_LABEL: Record<SerializedTransferStage['owner'], string> = {
  seller: 'Seller', buyer: 'Buyer', rubytill: 'Us', iso: 'Payments partner', system: 'Automatic',
};
export const OWNER_CHIP: Record<SerializedTransferStage['owner'], string> = {
  seller: 'bg-amber-100 text-amber-800', buyer: 'bg-amber-100 text-amber-800', rubytill: 'bg-rose-100 text-rose-700',
  iso: 'bg-slate-200 text-slate-700', system: 'bg-stone-200 text-stone-700',
};
export const AGE_CHIP = { ok: 'bg-emerald-100 text-emerald-800', warn: 'bg-amber-100 text-amber-800', stuck: 'bg-red-100 text-red-800' } as const;

export const STATUS_LABEL: Record<TransferStatus, string> = {
  buyer_onboarding: 'Buyer onboarding', card_processing: 'Card processing', ready_to_run: 'Ready to run', scheduled: 'Scheduled',
  running: 'Running', awaiting_merchant_link: 'Awaiting merchant link', completed: 'Completed', failed: 'Failed', cancelled: 'Cancelled',
};
